import { Badge, BadgeProps, makeStyles, mergeClasses, shorthands, tokens } from '@fluentui/react-components';

// Fluent ships no pale-blue tint token, so 'blue' mixes the family tokens per the preset formula:
// pale family bg, mid family border, dark family text.
const useCustomColorStyles = makeStyles({
  blue: {
    color: tokens.colorPaletteBlueForeground2,
    backgroundColor: `color-mix(in srgb, ${tokens.colorPaletteBlueBorderActive} 8%, ${tokens.colorNeutralBackground1})`,
    ...shorthands.borderColor(tokens.colorPaletteBlueBackground2),
  },
});

export type TTintBadgeColor = BadgeProps['color'] | 'blue';

type TProps = Omit<BadgeProps, 'color'> & { color?: TTintBadgeColor };

/** Status badge with the app's extended color set: Fluent presets pass through, custom families live here. */
const TintBadge = ({ color, appearance = 'tint', className, ...props }: TProps) => {
  const classes = useCustomColorStyles();
  const isCustom = color === 'blue';
  return (
    <Badge
      appearance={appearance}
      color={isCustom ? undefined : (color as BadgeProps['color'])}
      className={mergeClasses(isCustom ? classes.blue : undefined, className)}
      {...props}
    />
  );
};

export default TintBadge;
